import {
  buildCreateApi,
  coreModule,
  reactHooksModule,
} from '@reduxjs/toolkit/query/react';

import { tackleBoxModule } from './module';

export const createApi = buildCreateApi(
  coreModule(),
  tackleBoxModule(),
  reactHooksModule(),
);
